module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S7 Silver.1b4ee405.png";